import './password_change_form.css';
import { useAuth } from '../../context/AuthContext';
import { BarLoader } from '../BarLoader/BarLoader';
import { forwardRef, useState } from "react";
import { useServer } from '../../context/serverContext';
import { endpoints } from '../../env';
import { useLang } from '../../context/LangContext';

export const PasswordChangeForm = forwardRef((props, ref) => {
    const { user } = useAuth();
    const { postRequest } = useServer();
    const { lang } = useLang();

    //STATES
    const [pwd, setPwd] = useState("");
    const [pwdRepeat, setPwdRepeat] = useState("");
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    //FUNCTIONS
    const discardChanges = () => {
        setPwd("");
        setPwdRepeat("");
        setErrorMsg("");
    }

    const postChange = () => {
        if (loading) {
            return;
        }

        if (pwd !== pwdRepeat) {
            if (lang === "en") {
                setErrorMsg("The passwords do not match");
            } else {
                setErrorMsg("Las contraseñas no coinciden");
            }
            return;
        }

        setLoading(true);
        setErrorMsg("");

        let data = {
            user_id: user.id,
            password: pwd,
        }

        postRequest(endpoints.changePwd, data, (res) => {
            setLoading(false);

            if (res[0]) {
                res = res[1];

                if (!res.success) {
                    if (lang === "en") {
                        setErrorMsg("The password is required");
                    } else {
                        setErrorMsg("Se requiere la contraseña nueva");
                    }
                } else {
                    setPwd("");
                    setPwdRepeat("");
                }
            } else {
                if (lang === "en") {
                    setErrorMsg("Server error, try again in a bit");
                } else {
                    setErrorMsg("Error del servidor, intente de nuevo en un momento");
                }
            }
        });
    }

    return (
        <>
            <div className='password_change_form'>
                <div className='input_container'>
                    <label>
                        { lang === "en" ? "New password" : "Nueva contraseña" }
                    </label>
                    <input type='password' placeholder={ lang === "en" ? "New password" : "Nueva contraseña" } value={pwd} onChange={(e) => setPwd(e.target.value)} />
                </div>
                <div className='input_container'>
                    <label>
                        { lang === "en" ? "Repeat password" : "Repita la contraseña" }
                    </label>
                    <input type='password' placeholder={ lang === "en" ? "Repeat password" : "Repita la contraseña" } value={pwdRepeat} onChange={(e) => setPwdRepeat(e.target.value)} />
                </div>
                
                {loading && 
                    (
                        <div className='loader'>
                            <BarLoader />
                        </div>
                    )
                }

                {errorMsg !== "" &&
                    (
                        <div className='error_msg'>
                            {errorMsg}
                        </div>
                    )
                }

                <div className='actions'>
                    <button disabled={loading} onClick={discardChanges}>
                        { lang === "en" ? "Discard changes" : "Descartar cambios"}
                    </button>
                    <button className='primary' disabled={loading} onClick={postChange}>
                        { lang === "en" ? "Save changes" : "Guardar cambios"}
                    </button>
                </div>
            </div>
        </>
    );
});